"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ChartDescription = _interopRequireDefault(require("../components/ChartDescription"));
require("../components/ChartSource.styled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TextChart = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  let {
    chart
  } = _ref;
  const {
    centered = false,
    size = "medium"
  } = chart.componentProps;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, chart.description && /*#__PURE__*/_react.default.createElement(_ChartDescription.default, {
    description: chart.description,
    centered: centered,
    size: size
  }), !chart.description && /*#__PURE__*/_react.default.createElement(_ChartDescription.default, {
    description: "Error in chart: Description Template cannot be empty.",
    centered: centered,
    size: size
  }));
});
var _default = TextChart;
exports.default = _default;